import {
  createAccessToken,
  deleteAccessToken,
  fetchAccessTokens,
} from 'admin/actions/access-tokens';
import { fetchOrganizations } from 'admin/actions/organization';
import { getPrivateMoneys } from 'admin/actions/private-moneys';
import { getShops } from 'admin/actions/shops';
import { getTerminals } from 'admin/actions/terminals';
import Select from 'admin/components/atoms/Select';
import ApiResult from 'admin/components/shared/ApiResult';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import { formatDate, formatUUID, toQueryParams } from 'admin/utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import styles from './styles.scss';

const StyledSelect = styled(Select)`
  width: 200px;
  margin-right: 10px;
`;

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
};

class ServiceSettingsAccessToken extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moneys: { rows: [], count: 0, pagination: {} },
      moneyId: this.props.user.defaultMoney().id,
      shopId: '',
      accessTokens: [],
      organizations: { rows: [], count: 0, pagination: {} },
      organizationCode: '',
      selectedToken: '',
      apiResult: {},
      isModalOpen: false,
    };
  }

  componentWillMount() {
    getPrivateMoneys(toQueryParams({ per_page: 10000 })).then((moneys) =>
      this.setState({ moneys })
    );
    fetchOrganizations(
      toQueryParams({ private_money_id: this.state.moneyId, per_page: 10000 })
    ).then((organizations) => this.setState({ organizations }));
  }

  onClickList() {
    fetchAccessTokens(`shop_id=${this.state.shopId}`)
      .then((accessTokens) => this.setState({ accessTokens }))
      .then(() => {
        if (this.state.accessTokens.length === 0) {
          this.flashApiResult({
            message: '選択した店舗に有効なアクセストークンはありません',
            isError: true,
          });
        }
      });
  }

  onChangeMoney(option) {
    this.setState(
      {
        moneyId: option.value,
        organizationCode: '',
        shopId: '',
        accessTokens: [],
      },
      () => {
        const query = toQueryParams({ private_money_id: this.state.moneyId, per_page: 10000 });
        fetchOrganizations(query).then((organizations) => this.setState({ organizations }));
      }
    );
  }

  onChangeOrganization(option) {
    this.setState({ organizationCode: option.value, shopId: '', accessTokens: [] }, () => {
      // TODO: should fix per_page=1000
      // do not want the response to be paged
      this.props.getShops(`organization_code=${this.state.organizationCode}&per_page=1000`);
    });
  }

  onChangeShop(option) {
    this.setState({ shopId: option.value, accessTokens: [] });
  }

  onClickCreate(e) {
    const postData = { shop_id: this.state.shopId, organization_code: this.state.organizationCode };
    createAccessToken(postData)
      .then((newToken) => {
        this.flashApiResult({ message: '正常にアクセストークン生成されました', isError: false });
        this.setState({ accessTokens: this.state.accessTokens.concat([newToken]) });
      })
      .catch((err) => {
        err.then((msg) => {
          this.flashApiResult({ message: msg.message, isError: true });
        });
      });
  }

  onClickDelete(selectedToken, e) {
    this.setState({ selectedToken });
    this.openModal();
  }

  onSubmitDelete(e) {
    deleteAccessToken(this.state.selectedToken)
      .then(() => {
        this.closeModal();
        this.flashApiResult({ message: '正常に削除されました', isError: false });
        _.remove(this.state.accessTokens, (t) => t.access_token === this.state.selectedToken);
      })
      .catch((err) => {
        err.then((msg) => {
          this.closeModal();
          this.flashApiResult({ message: msg.message, isError: true });
        });
      });
  }

  moneyOptions() {
    return _.map(this.state.moneys.rows, (m) => {
      return {
        value: m.id,
        label: m.name,
      };
    });
  }

  organizationOptions() {
    return _.map(this.state.organizations.rows, (o) => {
      return { value: o.code, label: o.name };
    });
  }

  shopOptions() {
    return _.map(this.props.shops.rows, (s) => {
      return { value: s.id, label: s.name };
    });
  }

  terminalOptions() {
    return _.map(this.props.terminals, (t) => {
      return { value: t.hardware_id, label: t.name };
    });
  }

  flashApiResult({ message, isError = false }) {
    this.setState({ apiResult: { message, isError } });
    setTimeout(() => this.setState({ apiResult: {} }), 1000);
  }

  isCreateable() {
    return this.state.shopId;
  }

  openModal() {
    this.setState({ isModalOpen: true });
  }

  closeModal() {
    this.setState({ isModalOpen: false });
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: 'サービス管理', href: '', active: true },
      { value: 'アクセストークン管理', href: '', active: true },
    ];
    const columns = [
      { label: 'AccessToken', size: 6 },
      { label: 'ExpiresAt', size: 2 },
      { label: 'TerminalId', size: 1 },
      { label: 'TerminalName', size: 2 },
      { label: '', size: 1 },
    ];
    const rows = this.state.accessTokens.map((token) => [
      { data: <span>{token.access_token}</span> },
      { data: <span>{formatDate(token.expires_at)}</span> },
      { data: <span>{formatUUID(token.terminal.id)}</span> },
      { data: <span>{token.terminal.name}</span> },
      {
        data: (
          <Button color="danger" onClick={this.onClickDelete.bind(this, token.access_token)}>
            削除...
          </Button>
        ),
      },
    ]);

    const moneyOptions = this.moneyOptions();
    const organizationOptions = this.organizationOptions();
    const shopOptions = this.shopOptions();

    return (
      <div>
        <Breadcrumb items={crumb} />
        <div>
          <label htmlFor="organization_select" className={styles.label}>
            マネー
          </label>
          <StyledSelect
            id="private_money_select"
            options={moneyOptions}
            onChange={this.onChangeMoney.bind(this)}
            value={moneyOptions.find((option) => option.value === this.state.moneyId)}
            styles={{
              menu: (base) => ({ ...base, width: '320px' }),
              option: (base) => ({ ...base, minWidth: '320px', width: 'fit-content' }),
            }}
          />
          <label htmlFor="organization_select" className={styles.label}>
            組織
          </label>
          <StyledSelect
            id="organization_select"
            options={organizationOptions}
            onChange={this.onChangeOrganization.bind(this)}
            placeholder="すべて"
            value={organizationOptions.find(
              (option) => option.value === this.state.organizationCode
            )}
            styles={{
              menu: (base) => ({ ...base, width: '320px' }),
              option: (base) => ({ ...base, minWidth: '320px', width: 'fit-content' }),
            }}
          />
          <label htmlFor="sender_select" className={styles.label}>
            店舗
          </label>
          <StyledSelect
            id="sender_select"
            options={shopOptions}
            onChange={this.onChangeShop.bind(this)}
            placeholder="すべて"
            value={shopOptions.find((option) => option.value === this.state.shopId)}
            isDisabled={!(this.state.organizationCode.length > 0)}
            styles={{
              menu: (base) => ({ ...base, width: '320px' }),
              option: (base) => ({ ...base, minWidth: '320px', width: 'fit-content' }),
            }}
          />
          <Button
            onClick={this.onClickList.bind(this)}
            className={styles.btn}
            disabled={!(this.state.shopId.length > 0)}
          >
            一覧
          </Button>
          <Button
            onClick={this.onClickCreate.bind(this)}
            className={styles.btn}
            disabled={!this.isCreateable()}
          >
            新規作成
          </Button>
          <ApiResult
            message={this.state.apiResult.message}
            isError={this.state.apiResult.isError}
          />
        </div>
        <div styleName="list-table">
          <TableHeader columns={columns} />
          <TableRows rows={rows} columns={columns} />
        </div>

        <Modal
          isOpen={this.state.isModalOpen}
          onRequestClose={this.closeModal.bind(this)}
          shouldCloseOnOverlayClick={true}
          closeTimeoutMS={200}
          ariaHideApp={false}
          style={modalStyles}
        >
          <div>アクセストークンを削除してもよろしいですか？</div>
          <div styleName="button-group">
            <Button onClick={this.closeModal.bind(this)} color="gray">
              キャンセル
            </Button>
            <Button onClick={this.onSubmitDelete.bind(this)} color="danger">
              実行
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

ServiceSettingsAccessToken.propTypes = {
  user: PropTypes.object.isRequired,
  getShops: PropTypes.func.isRequired,
  shops: PropTypes.shape({
    rows: PropTypes.array,
    pagination: PropTypes.object,
  }),
  terminals: PropTypes.arrayOf(PropTypes.object),
};

ServiceSettingsAccessToken.defaultProps = {
  shops: { rows: [], pagination: {} },
  terminals: [],
};

const mapStateToProps = (state) => ({
  user: state.user,
  shops: state.shop.shops,
  terminals: state.terminal.terminals,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ getShops, getTerminals }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CSSModules(ServiceSettingsAccessToken, styles));
